import { render } from "./BlFlowForm.vue?vue&type=template&id=cd09413e&scoped=true"
import script from "./BlFlowForm.vue?vue&type=script&lang=js"
export * from "./BlFlowForm.vue?vue&type=script&lang=js"

import "./BlFlowForm.vue?vue&type=style&index=0&id=cd09413e&scoped=true&lang=scss"

import exportComponent from "/tmp/eb47f32b-990a-42a6-a461-0a5e6cce3094/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd09413e"]])

export default __exports__